export default __webpack_public_path__ + "static/media/honey.fca64364.jpg";